// extracted by css-extract-rspack-plugin
export default {"cls1":"Base-cls1_G9G","cls2":"Base-cls2_Pkc Base-cls1_G9G"};